import { EOrganizationType } from "../../interfaces/interfaces";

const OrganizationForm: React.FC<{
  newOrganizationValue: string;
  setNewOrganizationValue: React.Dispatch<React.SetStateAction<string>>;
  typeOfOrganization?: EOrganizationType;
  setTypeOfOrganization?: React.Dispatch<
    React.SetStateAction<EOrganizationType>
  >;
  closeModal: () => void;
  handleSubmit(e: React.FormEvent<HTMLFormElement>): void;
}> = ({
  newOrganizationValue,
  setNewOrganizationValue,
  typeOfOrganization,
  setTypeOfOrganization,
  closeModal,
  handleSubmit,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-create-body-inner">
        <div className="modal-input-container">
          <label
            htmlFor="organization-name"
            data-testid="create-organization-name"
          >
            Organization Name
          </label>
          <input
            className="modal-input"
            name="organization-name"
            value={newOrganizationValue}
            onChange={(e) => setNewOrganizationValue(e.target.value)}
          />
        </div>
        {setTypeOfOrganization && (
          <div className="modal-input-container">
            <label
              htmlFor="organization-type"
              data-testid="create-organization-type"
            >
              Organization Type
            </label>
            <select
              className="modal-input modal-input-select"
              name="organization-type"
              value={typeOfOrganization}
              onChange={(e) =>
                setTypeOfOrganization(e.target.value as EOrganizationType)
              }
            >
              <option value={EOrganizationType.PRO_VIEW_ORGANIZATION}>
                Pro View Organization
              </option>
              <option value={EOrganizationType.BCC_ORGANIZATION}>
                BCC Organization
              </option>
            </select>
          </div>
        )}
      </div>
      <div className="margin-bottom-small" />
      <div className="modal-input-actions">
        <button
          type="button"
          className="tertiary-btn-small"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          disabled={newOrganizationValue === ""}
          type="submit"
          className="tertiary-btn-small user-card-action-btn user-card-action-btn-resend"
        >
          Confirm
        </button>
      </div>
    </form>
  );
};

export default OrganizationForm;
